import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { AddCommentSup } from "../../Api/ClientServices";
import { errorToast, succToast } from "../../Toast/Toast";
import AddRate from "../AddRate/AddRate";
import Button from "../Button/Button";
import Input from "./../Input/Input";
import Style from "./AddComment.module.css";
const AddComment = (props) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const onSubmitHandler = (data) => {};
  const [comment, setComment] = useState();
  const [disable, setDisable] = useState(false);
  const [Rate, setRate] = useState(50);

  const rate = Math.round(Rate / 20);

  const opinionHandle = () => {
    setDisable(true);
    const commentInfo = {
      supplier_id: props.commentSupId,
      order_id: props.commentProId,
      score: rate,
      message: comment,
    };
    AddCommentSup(commentInfo, (suc, res) => {
      if (res.status === 0) {
        errorToast(res.message);
        setDisable(false);
      } else {
        succToast(res.message);
        props.close();
      }
    });
    props.getPastOrders();
  };
  return (
    <>
      <AddRate rate={Rate} setRate={setRate} />
      <div className={Style.AddCommentHolder}>
        <form
          onSubmit={handleSubmit(onSubmitHandler)}
          className={Style.CodeHolder}
        >
          <Input
            {...register("address", { required: true })}
            inputtype={errors.address ? "validTextArea" : "textArea"}
            type="textarea"
            placeholder={"نظر خودرا بنويسيد..."}
            onChange={(e) => setComment(e.target.value)}
          />
          <div className={Style.BtnHolder}>
            <Button
              ClassBtn={"confrimBtn"}
              Value={"ثبت نظر"}
              ClickHandler={opinionHandle}
              disabledProps={disable} 
            />
          </div>
        </form>
      </div>
    </>
  );
};

export default AddComment;
